
export const QUERY__EMPLOYER__SIMPLE_SINGLE = {
  fields: ['id', 'name', 'state', 'updatedAt'],
  limit: 1
};
